import {useCallback} from 'react';
import useSWR from 'swr';
import StarmaniaApi from '@deezer/next/services/api/Starmania';
import type {Country} from '@deezer/next/services/api/Starmania/requests/utils/types';

const COUNTRY_OPTIONS_KEY = 'analytics/filter/countries';
const OPTIONS_DEDUPING_INTERVAL = 60_000;

const fetchCountries = async (): Promise<Country[]> => {
	const res = await StarmaniaApi.utils.getCountries();
	return res.data;
};

export const useCountryOptions = () => {
	const {data, error, isLoading, isValidating, mutate} = useSWR<Country[]>(
		COUNTRY_OPTIONS_KEY,
		fetchCountries,
		{
			revalidateOnFocus: false,
			revalidateIfStale: false,
			revalidateOnReconnect: false,
			shouldRetryOnError: false,
			dedupingInterval: OPTIONS_DEDUPING_INTERVAL,
			focusThrottleInterval: OPTIONS_DEDUPING_INTERVAL,
		},
	);

	const reload = useCallback(() => {
		return mutate();
	}, [mutate]);

	return {
		countryList: data ?? [],
		isLoading,
		isValidating,
		error,
		reload,
	};
};
